import { EAdsTabs } from "app/components/React/PlaResearch/type";
import { proNavigator } from "single-spa/react-app/ProNavigator";

export const resolveChildStates = (webSource: string) => {
    const selectedPageTabs = proNavigator.getParams().selectedPageTab;
    if (selectedPageTabs === EAdsTabs[EAdsTabs.Product]) {
        return webSource === "mobileweb" ? "MobileWebSearch" : "ProductAds";
    } else {
        return "";
    }
};

export const isProduct = () => {
    const selectedPageTabs = proNavigator.getParams().selectedPageTab;
    return selectedPageTabs === EAdsTabs[EAdsTabs.Product];
};
export const isSearch = () => {
    const selectedPageTabs = proNavigator.getParams().selectedPageTab;
    return selectedPageTabs === EAdsTabs[EAdsTabs.Text];
};
